// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j8-0";
export var actionModalContentContainer = "_j8-1";
export var createTagButton = "_j8-2";
export var footerContainer = "_j8-7";
export var fullWidthDivider = "_j8-3";
export var hasCreateTagButton = "_j8-4";
export var noCreateTagButton = "_j8-5";
export var tagsContainer = "_j8-6";
export var tagsModalContentContainer = "_j8-8";